import { DeleteFacesFeature } from '@models/classes/features/delete-faces-feature';
import { Token } from '@models/classes/token';
import { ITrackedClass } from '@models/interfaces/tracked-class';
import { SubmeshVertexData } from '@view/helpers/geometry-helper';
import { FeatureRenderer } from './feature';

export class DeleteFacesRenderer extends FeatureRenderer<DeleteFacesFeature> {
    modelToken = Token.DeleteFacesFeature;
    updateMeshGeometry(
        feature: ITrackedClass<DeleteFacesFeature>,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const newVertexData = super.updateMeshGeometry(feature, vertexData, vertexDataChanges);

        if (newVertexData.indices && feature.vertexGroups.length > 0) {
            const vertexGroups = feature.vertexGroups.sort((groupA, groupB) => groupA.startIndex - groupB.startIndex);
            const newIndices = new Int32Array(newVertexData.indices);
            let currReadIndex = 0;

            vertexGroups.forEach(vertexGroup => {
                for (
                    let i = Math.max(vertexGroup.startIndex, currReadIndex);
                    i < Math.min(vertexGroup.endIndex, newIndices.length);
                    i++
                ) {
                    newIndices[i] = -1;
                }
                currReadIndex = vertexGroup.endIndex;
            });

            // We need to remove submeshes targetting the indices that are being removed as well
            if (newVertexData.submeshData) {
                newVertexData.submeshData.forEach(submeshData => {
                    const indexStart = submeshData.indexStart;
                    for (let i = 0; i < indexStart; i++) {
                        if (newIndices[i] === -1) {
                            submeshData.indexStart--;
                        }
                    }
                    const indexCount = submeshData.indexCount;
                    for (let i = 0; i < indexCount; i++) {
                        const index = indexStart + i;
                        if (newIndices[index] === -1) {
                            submeshData.indexCount--;
                        }
                    }
                });
            }

            newVertexData.indices = newIndices.filter(index => index !== -1);
        }
        return newVertexData;
    }

    update3dInternal() {}
}
